/* Reads native scroll only; the Phase F motion and commerce controllers remain shared. */
function headerProgress(scroll, distance = 160) {
  return Math.min(1, Math.max(0, scroll / distance));
}

function createHeaderUpdate(header) {
  let previous = -1;
  return (scroll, distance) => {
    const progress = headerProgress(scroll, distance);
    if (progress === previous) return;
    previous = progress;
    header.style.setProperty('--header-progress', progress);
  };
}

async function setupHeroVideo(video, connection) {
  let revision = 0;
  // Bandwidth, not motion: data-saver and 2G connections keep the still hero instead of streaming the film.
  const restricted = () => connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '');
  const fallback = () => { video.classList.remove('is-playing'); };
  async function play() {
    const current = ++revision;
    video.muted = true;
    try {
      await video.play();
      if (current !== revision || restricted()) return;
      video.classList.add('is-playing');
    } catch {
      if (current === revision) {
        video.removeAttribute('autoplay');
        video.pause();
        fallback();
      }
    }
  }
  function stop() {
    ++revision;
    video.pause();
    video.removeAttribute('src');
    video.load();
    fallback();
  }
  function start() {
    // Phones get a portrait cut, so the whole bitrate lands on the visible crop.
    video.src = (matchMedia('(max-width: 600px)').matches && video.dataset.srcMobile) || video.dataset.src;
    return play();
  }
  connection?.addEventListener?.('change', () => { if (restricted()) stop(); });
  video.addEventListener('error', fallback);
  if (restricted()) return;
  await start();
}

document.addEventListener('DOMContentLoaded', () => {
  // Full motion for every visitor: the approved motion runs regardless of the OS Reduce Motion setting.
  const header = document.querySelector('.site-header[data-cinematic]');
  if (header) {
    const render = createHeaderUpdate(header);
    const hero = document.querySelector('.hero-section');
    let queued = false, scroll = window.scrollY, distance = 160;
    const update = () => {
      queued = false;
      render(scroll, distance);
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    // How far the page scrolls before the header surface is fully in: measured on resize, never in the scroll frame.
    const measure = () => {
      distance = Math.max(240, Math.min(560, (hero?.offsetHeight || innerHeight) * .55));
      schedule();
    };
    window.addEventListener('scroll', () => { scroll = window.scrollY; schedule(); }, {passive:true});
    window.addEventListener('resize', measure, {passive:true});
    measure();
  }
  const video = document.querySelector('[data-hero-video]');
  if (video) setupHeroVideo(video, navigator.connection);
});
